// ─────────────────────────────────────────────────────────────────────────────
// suppliers.js
// ─────────────────────────────────────────────────────────────────────────────

import miavitLogo  from '@assets/images/suppliers/miavit-logo.png'
import technaLogo  from '@assets/images/suppliers/techna-logo.png'
import stiLogo     from '@assets/images/suppliers/sti-logo.png'
import texLogo     from '@assets/images/suppliers/tex-logo.png'
import omegaLogo   from '@assets/images/suppliers/omega-logo.png'

export const suppliers = [
  {
    id:           'miavit',
    name:         'MIAVIT GmbH',
    shortName:    'MIAVIT',
    country:      'Germany',
    flag:         '🇩🇪',
    website:      'https://miavit.com/',
    logo:         miavitLogo,
    brandColor:   '#c0392b',
    description:  'A leading German manufacturer of vitamins, amino acids, minerals, and specialty feed additives for animal nutrition. MIAVIT has been a trusted name in premix manufacturing since 1964, offering science-backed nutritional solutions for poultry and dairy.',
    specialties:  [
      'Vitamin & Mineral Supplements',
      'Premixes',
      'Gut Health Products',
      'Liver Health',
      'Electrolytes',
      'Organic Acids',
      'Essential Oils',
    ],
    certifications: ['GMP+', 'FAMI-QS'],
    sectors:      ['Poultry', 'Dairy'],
    since:        '2022',
  },
  {
    id:           'technafeedia',
    name:         'TECHNA Feedia',
    shortName:    'TECHNA',
    country:      'France',
    flag:         '🇫🇷',
    website:      'https://www.groupe-techna.com/en/feedia',
    logo:         technaLogo,
    brandColor:   '#2c6fad',
    description:  'A pioneering French animal nutrition company with roots dating back to 1964. TECHNA\'s Feedia range delivers precision nutrition solutions, innovative additives, premixes, and digital decision-support tools for feed manufacturers and livestock producers across poultry, ruminants, swine, and aquaculture sectors.',
    specialties:  [
      'Precision Nutrition Solutions',
      'Premixes & Concentrates',
      'Performance Additives',
      'Gut Health & Essential Oils',
      'Pigmentation Solutions',
      'Reproductive Performance',
      'Feed Formulation & Lab Analysis',
    ],
    certifications: ['ISO 9001', 'FAMI-QS'],
    sectors:      ['Poultry', 'Dairy', 'Ruminants'],
    since:        '2024',
  },
  {
    id:           'stibiotechnologie',
    name:         'STI Biotechnologie',
    shortName:    'STI BIO',
    country:      'France',
    flag:         '🇫🇷',
    website:      'https://www.sti-biotechnologie.fr/en/',
    logo:         stiLogo,
    brandColor:   '#3a7d44',
    description:  'An innovative French biotech company based in Brittany, founded in 2007, specialising in natural lactobacillus-based solutions for animal nutrition and agro-environment. STI Biotechnologie develops exclusive probiotic and postbiotic products derived from proprietary Lactobacillus strains, promoting digestive health, immunity, and sustainable farming practices across all livestock species.',
    specialties:  [
      'Probiotic Feed Additives',
      'Postbiotic Solutions',
      'Lactobacillus Complexes',
      'Gut Health & Digestive Balance',
      'Silage Preservatives',
      'Agro-Environmental Solutions',
    ],
    certifications: [],
    sectors:      ['Poultry', 'Dairy', 'Ruminants'],
    since:        '2024',
  },
  {
    id:           'texbiosciences',
    name:         'Tex Biosciences',
    shortName:    'TEX BIO',
    country:      'India',
    flag:         '🇮🇳',
    website:      'https://texbiosciences.com/',
    logo:         texLogo,
    brandColor:   '#1a6b3c',
    description:  'An innovative Indian biotech company specializing in enzyme solutions and performance enhancement products for livestock. Tex Biosciences delivers cutting-edge biological feed additives including phytases and emulsifiers for poultry nutrition.',
    specialties:  [
      'Phytase Enzymes',
      'Feed Emulsifiers',
      'Performance Enhancers',
    ],
    certifications: [],
    sectors:      ['Poultry'],
    since:        '2022',
  },
  {
    id:           'omegapharma',
    name:         'Omega Pharma',
    shortName:    'OMEGA',
    country:      'Vietnam',
    flag:         '🇻🇳',
    website:      'https://omegapharma.com.vn/',
    logo:         omegaLogo,
    brandColor:   '#1565c0',
    description:  'A reputable Vietnamese pharmaceutical and animal health company producing high-quality veterinary products and nutritional supplements. Omega Pharma supplies electrolyte and heat stress management solutions for poultry.',
    specialties:  [
      'Electrolyte Supplements',
      'Heat Stress Management',
      'Animal Health Products',
    ],
    certifications: [],
    sectors:      ['Poultry'],
    since:        '2023',
  },
]

export default suppliers